import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { ModuleDataHandler } from '../../helpers/handleReportCalc';

const style1 = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '60.4px',
  width: '100%',
  border: '3px solid #d0ebff',
};
interface IProps {
  moduleData: any;
  isView: boolean;
  item: any;
  index: number;
}
const TBodyRow = ({ moduleData, isView, item, index }: IProps) => {
  const [render, setRender] = useState(false);
  const dataHandler = new ModuleDataHandler(moduleData);

  return (
    <>
      <tr>
        <td>
          {item?.customer_name ||
            (typeof item?.part_id !== 'string' &&
              item?.part_id?.customer_id.customer_name)}
        </td>
        <td>
          {item?.part_number ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_number)}
        </td>
        <td>
          {item?.part_name ||
            (typeof item?.part_id !== 'string' && item?.part_id?.part_name)}
        </td>
        <td>{item?.rm_grade}</td>
        <td>
          {item?.sale_rate ||
            (typeof item?.part_id !== 'string' && item?.part_id?.sale_rate)}
        </td>
        <td>{item?.rm_thick}</td>
        <td>{item?.rm_width}</td>
        <td>{item?.rm_length}</td>
        <td>{item?.rm_strip_wt}</td>
        <td>{item?.rm_no_of_pc}</td>
        <td>{item?.rm_gross_wt}</td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.inventry_wgt_rm || null}
            onChange={(e) => {
              item.inventry_wgt_rm = Number(e.target.value);
              dataHandler.handelRmPlanningCalc(index);
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={isView}
            type="number"
            value={item.inventry_qty_rm || null}
            onChange={(e) => {
              item.inventry_qty_rm = Number(e.target.value);
              dataHandler.handelRmPlanningCalc(index);
              setRender((prev) => !prev);
            }}
          />
        </td>
        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.total_inventry_qty || null}
          />
        </td>
        <td style={{ maxWidth: '80px' }}>
          <span style={style1}>{item.sale_plan}</span>
        </td>
        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.rm_required_qty || null}
          />
        </td>
        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.rm_required_weight || null}
          />
        </td>

        <td style={{ maxWidth: '80px' }}>
          <span style={style1}>{item?.rm_input_weight}</span>
        </td>

        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.balance_rm || null}
          />
        </td>
        <td> {item?.total_dispatch}</td>
        <td>
          <TableInput
            isView={true}
            type="number"
            value={item.closing_inventry_qty || null}
          />
        </td>
      </tr>
    </>
  );
};

export default TBodyRow;
